module.exports = __webpack_public_path__ + "b14abf3905e15f1b5ff14905f913afde.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/iconos/facturacionicon.png
// module id = 2157
// module chunks = 0